import React, { useState } from "react";
import {
  Card,
  Avatar,
  Descriptions,
  Divider,
  Modal,
  Button,
  Form,
  Typography,
} from "antd";
import { useUser } from "../contexts/UserContext";
import LogoutButton from "../components/auth/LogoutButton";
import ProfileEditForm from "../components/profile/ProfileEditForm";

const { Title } = Typography;
const Profile = () => {
  const { currentUser } = useUser();
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const [profile, setProfile] = useState(currentUser);

  const handleEdit = () => {
    setOpenModal(true);
    form.setFieldsValue({
      username: profile?.username,
      address: profile?.address,
      unitNumber: profile?.unitNumber,
    });
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "50px" }}>
      <Card
        style={{ width: 400, boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}
        cover={
          <Avatar
            src={
              profile.photoUrl
                ? `${profile.photoUrl}?v=${profile.photoVersion}`
                : "/default-avatar.png"
            }
            size={250}
            style={{
              margin: "20px auto",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        }
      >
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <Title level={3}>{profile?.username}</Title>
          <Title level={3} style={{ color: "#888" }}>
            {profile?.email}
          </Title>
        </div>
        <Divider />
        <Descriptions layout="vertical" bordered column={1}>
          <Descriptions.Item label={<strong>Address</strong>}>
            {profile?.unitNumber
              ? `${profile?.address} ${profile?.unitNumber}`
              : profile?.address}
          </Descriptions.Item>
          <Descriptions.Item label={<strong>Rating</strong>}>
            {profile?.averageRating > 0 ? (
              <>
                {profile.averageRating.toFixed(1)} ⭐{" "}
                <span> ({profile?.ratingCount} reviews)</span>
              </>
            ) : (
              <span>No reviews</span>
            )}
          </Descriptions.Item>
          <Descriptions.Item label={<strong>Member Since</strong>}>
            {new Date(profile?.createdAt).toLocaleDateString()}
          </Descriptions.Item>
        </Descriptions>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            onClick={handleEdit}
            style={{ minWidth: "100px" }}
          >
            Edit Profile
          </Button>
          <LogoutButton />
        </div>
      </Card>
      <Modal
        open={openModal}
        footer={null}
        width={800}
        closable={false}
        centered={true}
      >
        <ProfileEditForm
          setOpenModal={setOpenModal}
          setProfile={setProfile}
          form={form}
          profile={profile}
        />
      </Modal>
    </div>
  );
};

export default Profile;
